import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResProduct, ResSearchFilterSmart, ResSearchFilterOnBooking, ResSearchFilterOnBookingStatus, ResSearchFilterPreferences, ResProductType } from '../models/res-package.model';
import { GeoTreeDestination } from '@app/res-setup/models/resadm-geo.model';
import { ResAdmAmenityTree } from '@app/res-common/models/rescom.model';
import { EidosUtilityService } from '@app/core/services/eidos-utility.service';
import { ResBooking } from '../models/res-booking.model';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  productSearchSmartFilters = new BehaviorSubject<ResSearchFilterSmart[]>([])
  productSearchFilterUserPreferences: any | null = null // product search filters selected by the user
  checkedProductsList =  new BehaviorSubject<ResProduct[]>([]); //FOR POSSIBLE FUTURE USES -> list of all products checked by the user
  checkedCombinableProductsList =  new BehaviorSubject<ResProduct[]>([]); // list of combinable products checked by the user
  isProductSearchFiltersCleaned = new BehaviorSubject<boolean>(false) // subscribe to it to handle when the user click on the clear button in the search bar
  selectedDestinations = new BehaviorSubject<GeoTreeDestination[]>([]);
  selectedAmenities = new BehaviorSubject<ResAdmAmenityTree[]>([]);

  openTmOnProduct =  new BehaviorSubject<ResProduct|null>(null);
  productSearchFiltersStatus = new ResSearchFilterOnBookingStatus()
  smartFilterOnBookingStatus = new BehaviorSubject<boolean>(false)
  constructor(
    private eidosUtilityService: EidosUtilityService,
  ) {}

  clearFilterStatus() {
    this.productSearchFiltersStatus.onBooking = false
    this.productSearchFiltersStatus.previousFilters = {}
  }
  setFilterOnBookingFromBooking(booking:ResBooking,productType:ResProductType,preferences:any){
    this.clearFilterStatus()
    const params = new ResSearchFilterOnBooking()
    params.companies = [booking.companyID]
    params.productCodes = [productType]
    params.priceTypes = booking.priceTypeID ? [booking.priceTypeID] : []
    params.currencies = [booking.bkgCurrency]
    params.preferences = preferences
    this.setFilterOnBooking(params)
  }
  setFilterOnBooking(params:ResSearchFilterOnBooking) {
    this.loadSmartFilter(params.preferences)
    this.productSearchFiltersStatus.onBooking = true
    this.productSearchFiltersStatus.previousFilters = this.eidosUtilityService.cloneDeep(this.productSearchFilterUserPreferences)
    this.productSearchFilterUserPreferences = {
      companies: params.companies,
      productCod: params.productCodes,
      //          monthFrom: Array.from(months),
      currency: params.currencies,
      priceType: params.priceTypes,
    }
    this.productSearchFiltersStatus.onBooking = true
    const newSmartFilters = this.productSearchSmartFilters.getValue()
    if(newSmartFilters.length===0) return
    this.productSearchFiltersStatus.previousSmartFilters = this.eidosUtilityService.cloneDeep(newSmartFilters)
    newSmartFilters.forEach(sf=>{
      switch(sf.section) {
        case 'PRODUCT CODES':
          sf.disabled = true
          sf.items.forEach(item=>{
            item.on = params.productCodes.includes(item.cod)
          })
          break;
      }
    })
    this.smartFilterOnBookingStatus.next(true)
    this.productSearchSmartFilters.next(newSmartFilters)
    this.setCurrenciesFilterOnBookingBehavior()
  }
  setCurrenciesFilterOnBookingBehavior() {

  }
  setCurrenciesFilter() {
    if(this.productSearchFiltersStatus.onBooking) {
      this.setCurrenciesFilterOnBookingBehavior()
      return
    }

  }
  resetFilterOnBooking(filters:ResSearchFilterPreferences) {
    this.productSearchFiltersStatus.onBooking = false
    this.productSearchFilterUserPreferences = {}
    const newSmartFilters = this.productSearchFiltersStatus.previousSmartFilters.length > 0
                          ? this.productSearchFiltersStatus.previousSmartFilters
                          : filters.smartFilters
    const productCodes = filters.values.productCodes
    newSmartFilters.forEach(sf=>{
      switch(sf.section) {
        case 'PRODUCT CODES':
          sf.disabled = false
          if(!sf.items.find(item=>item.favourite)) {
            sf.items.forEach(item=>{
              item.on = productCodes.includes(item.cod) || item.on
            })
          }
          break;
      }
    })
    this.productSearchSmartFilters.next(this.productSearchFiltersStatus.previousFilters)

  }
  setFilterOffBooking() {
    this.productSearchFiltersStatus.onBooking = false
    this.setCurrenciesFilter()
    this.productSearchSmartFilters.next(this.productSearchFiltersStatus.previousSmartFilters)
    this.productSearchFilterUserPreferences = this.productSearchFiltersStatus.previousFilters
  }
  loadSmartFilter(preferences: ResSearchFilterPreferences, productCode?: string, onBooking = false) {
    const smartFilters = preferences.smartFilters
    .filter(sf=>sf.items.find(item=>item.on))
    .map(sf=>{
      if(productCode) {
        sf.disabled = true
        sf.items.forEach(item=>{
          item.on = item.cod===productCode
        })
      }

      const selected = new ResSearchFilterSmart()
      selected.section = sf.section
      selected.items = sf.items.filter(sf=>sf.on)
      return selected
    })

    if(!onBooking) this.productSearchSmartFilters.next(smartFilters)

    this.setCurrenciesFilter()
  }
  getSmartFilters(): any {

    let selectedProductCod = ''
    let selectedCompanies = ''
    let selectedCurrency = ''
    let destinations = ''
    let selectedPkgCategories = ''
    let selectedVillaCategories = ''
    const yearList:string[] = []
    const monthList:string[] = []
    let monthListFormatted = ''

    const smartFilters = this.productSearchSmartFilters.getValue()

    const regionsRemove = smartFilters.filter(sf=>sf.section==='COUNTRIES')
                                .flatMap(sf=>sf.items)
                                .filter(item=>item.relatedItem)
                                .map(item=>+item.relatedKey)
    const countriesRemove = smartFilters.filter(sf=>sf.section==='CITIES')
                                .flatMap(sf=>sf.items)
                                .filter(item=>item.relatedItem)
                                .map(item=>+item.relatedKey)
    let isSanctuaryAAndKey = false
    smartFilters.filter(sf=>sf.section==='FLAGS')
                .forEach(sf=>{
                  if(sf.items.find(i=>i.cod==='ONLYAK')) isSanctuaryAAndKey = true
                })

    smartFilters.forEach(sf=>{
      switch(sf.section) {
        case 'PRODUCT CODES':
          selectedProductCod = sf.items.map(item=>item.cod).join(',')
          break;
        case 'COMPANIES':
          selectedCompanies = sf.items.map(item=>item.id).join(',')
          break;
        case 'CURRENCIES':
          if(sf.items.length>0) selectedCurrency = sf.items[0].cod
          break;
        case 'REGIONS':
          destinations += (destinations==='' ? '' : ',')
                        + sf.items
                            .filter(item=>!regionsRemove.includes(item.id))
                            .map(item=>item.id).join(',')
          break;
        case 'COUNTRIES':
          destinations += (destinations==='' ? '' : ',')
                        + sf.items
                            .filter(item=>!countriesRemove.includes(item.id))
                            .map(item=>item.id).join(',')
          break;
        case 'CITIES':
          destinations += (destinations==='' ? '' : ',')
                        + sf.items
                            .map(item=>item.id).join(',')
          break;
        // case 'COUNTRIES':
        //   selectedCountries += (selectedCountries==='' ? '' : ',') + sf.items.map(item=>item.id).join(',')
        //   break;
        // case 'CITIES':
        //   selectedCities += (selectedCities==='' ? '' : ',') + sf.items.map(item=>item.id).join(',')
        //   break;
        case 'PKG CATEGORIES':
          selectedPkgCategories = sf.items.map(item=>item.cod).join(',')
          break;
        case 'VILLA CATEGORIES':
          selectedVillaCategories = sf.items.map(item=>item.cod).join(',')
          break;
        case 'YEARS':
          sf.items
            .map(item=> DateTime.now().plus({years:item.id})
            .toFormat('yyyy') )
            .forEach(y=>yearList.push(y))
          break;
        case 'MONTHS':
          sf.items
            .map(item=> DateTime.fromFormat(`2025-${item.id}-01`,'yyyy-L-dd')
            .toFormat('LL') )
            .forEach(m=>monthList.push(m))
          break;
      }
    })
    if(yearList.length===0 && monthList.length>0) {
      [DateTime.now().toFormat('yyyy'),
       DateTime.now().plus({years:1}).toFormat('yyyy'),
       DateTime.now().plus({years:2}).toFormat('yyyy'),
       DateTime.now().plus({years:3}).toFormat('yyyy')
      ].forEach(y=>yearList.push(y))
    } else if(yearList.length>0 && monthList.length===0) {
      ['01','02','03','04','05','06','07','08','09','10','11','12']
        .forEach(m=>monthList.push(m))
    }
    if(yearList.length>0) {
      monthListFormatted = yearList.map(y=>monthList.map(m=>`${y}${m}`)).flatMap(ym=>ym).join(',')
    }

    return {
      companiesID: selectedCompanies === '' ? undefined : selectedCompanies,
      productCodes: selectedProductCod === '' ? undefined : selectedProductCod,
      destinationsID: destinations === '' ? undefined : destinations,
      monthList: monthListFormatted === '' ? undefined : monthListFormatted,
      currency: selectedCurrency === '' ? undefined : selectedCurrency,
      categories: selectedPkgCategories === '' ? undefined : selectedPkgCategories,
      villaCategory: selectedVillaCategories === '' ? undefined : selectedVillaCategories,
      onlyAK: isSanctuaryAAndKey ? 'Y' : undefined
    };
  }
}
